import React, { useEffect, useState } from "react";

const stepsData = [
  {
    img: "user-gd.svg",
    description: "Hunting for profile details",
    status: "pending",
    printed: true,
  },
  {
    img: "beaker-gd.svg",
    description: "Curating appropriate features",
    status: "pending",
    printed: false,
  },
  {
    img: "bulb-gd.svg",
    description: "Analyzing the product fit",
    status: "pending",
    printed: false,
  },
  {
    img: "paper-note-gd.svg",
    description: "Crafting exquisite messages",
    status: "pending",
    printed: false,
  },
  {
    img: "ai-star-gd.svg",
    description: "Wrapping up and finalising",
    status: "pending",
    printed: false,
  },
];

export default function MessageDraftLoader() {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    setSteps(JSON.parse(JSON.stringify(stepsData)));
  }, []);

  useEffect(() => {
    if (steps && steps.length > 0) {
      const updateStepStatus = (index) => {
        if (index < steps.length - 1) {
          const id = setTimeout(() => {
            setSteps((prevSteps) => {
              const newSteps = [...prevSteps];
              newSteps[index].status = "completed";
              newSteps[index + 1].printed = true;
              return newSteps;
            });
            updateStepStatus(index + 1);
          }, 2500);
        } else if (index === steps.length - 1) {
          setSteps((prevSteps) => {
            const newSteps = [...prevSteps];
            newSteps[index].printed = true;
            return newSteps;
          });
        }
      };

      updateStepStatus(0);
    }
  }, [steps]);

  return (
    <div>
      {/* {steps &&
        steps.length > 0 &&
        steps.map((step, index) => (
          <div key={index}>
            {step.printed && (
              <h3 className="text-[14px] font-semibold flex items-center justify-center mt-5 slide-in">
                <img src={`images/${step.img}`} alt="User" className="mr-2 no-invert" />{" "}
                <span className="inline-block mr-2">{step.description}</span>
                {step.status === "pending" && (
                  <img
                    src="images/ext/loader-circle-gd.svg"
                    alt="Loader"
                    className="animate-spin no-invert"
                  />
                )}
                {step.status === "completed" && (
                  <Image className="no-invert" src="/images/ext/check-gd.svg" alt="Check" />
                )}
              </h3>
            )}
          </div>
        ))} */}
      <div className="flex flex-col justify-center items-center space-y-4">
        <div className="loader_circle loader_purple"></div>
        <span className="text-text-700 text-sm block">Hunting for Profile Signals</span>
      </div>
    </div>
  );
}
